import { applyLabTheme, toggleLabTheme, type LabTheme } from '@/lib/labTheme';
import { useCallback, useState } from 'react';

function readThemeFromDom(): LabTheme {
  return document.documentElement.dataset.labTheme === 'light' ? 'light' : 'dark';
}

export function useLabTheme() {
  const [theme, setTheme] = useState<LabTheme>(readThemeFromDom);

  const setLabTheme = useCallback((next: LabTheme) => {
    applyLabTheme(next);
    setTheme(next);
  }, []);

  const toggle = useCallback(() => {
    setTheme((current) => toggleLabTheme(current));
  }, []);

  return { theme, setLabTheme, toggle, isLight: theme === 'light' };
}
